import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../../shared/shared.module';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthenticationService } from '../../../core/service/auth/authentication.service';
import { PopupServiceService } from '../../../core/service/popup/popup-service.service';
import { LoaderService } from '../../../core/service/loader.service';
import { DomainConfigService } from '../../../core/service/domainConfig/domain-config.service';

interface ForgotPasswordForm {
  email: FormControl<string>;
}

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    MatDialogModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {

  tenantId = '';
  domain = '';

  private fb = inject(FormBuilder);
  private http = inject(HttpClient);
  private authService = inject(AuthenticationService);
  readonly popup = inject(PopupServiceService);
  readonly dialogRef = inject(MatDialogRef<ForgotPasswordComponent>);
  public loader = inject(LoaderService);
  private domainConfigService = inject(DomainConfigService);

  readonly forgotPasswordForm: FormGroup<ForgotPasswordForm> = this.fb.group({
    email: new FormControl('', {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
      ],
    }),
  });

  ngOnInit(): void {
    this.setupDomainBranding();
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.valid) {
      this.loader.show();
      const { email } = this.forgotPasswordForm.getRawValue();

      const payload = { email, tenantId: this.tenantId, domainName: this.domain };

      this.authService.forgotPassword(payload).subscribe({
        next: (response: any) => {
          this.loader.hide();
          this.dialogRef.close();
          const message = `<p>Email has been sent to <strong>${response?.data?.email}</strong>. Please check and click on the included link to reset your password.</p>`;
          this.popup.successAndErrorDialog('success', message);
        },
        error: (error: any) => {
          this.loader.hide();
          this.popup.successAndErrorDialog('error', error?.error?.message);
        },
      });
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }
  private setupDomainBranding(): void {
    this.tenantId = this.domainConfigService.getTenantId();
    this.domain = this.domainConfigService.getCurrentDomain();
  }
}
